import { useAppSelector } from "../store/hooks";

const useIsSsfBilling = (): { isSsfBilling: boolean } => {
  const draft = useAppSelector((state) => state.bills.draft);

  return { isSsfBilling: Boolean(draft?.isSsfBilling) };
};

export default useIsSsfBilling;
